const _ = require("lodash");

const settings = {
	staticMaxStars: true,
	canEarnStarsOnTrialSubmission: true,
	showMessageOnStarEarned: true,
	neverResumeResult: true,
	markCompletedAfterFirstTrial: true,
};

const getPercentComplete = function(result) {
	return result.streakScore / result.starCutoffs[0];
};

const isFinished = function(result) {
	return getStars(result) === 3 || result.hasQuit;
};

const getLastAvailableIndex = function(result) {
	return result.problems.length - 1;
};

const getLastPossibleIndex = function(result) {
	return result.problems.length - 1;
};

const getEquivalentCurrentProblem = function(result, oldResult) {
	if (oldResult.problems[result.currentProblemIndex]) {
		return oldResult.problems[result.currentProblemIndex];
	} else {
		//This must have been a problem in the old result set to be next
		const currentProblemID =
			result.problems[result.currentProblemIndex].problemID;
		if (currentProblemID === oldResult.nextProblemCorrect.problemID) {
			return oldResult.nextProblemCorrect;
		} else if (currentProblemID === oldResult.nextProblemIncorrect.problemID) {
			return oldResult.nextProblemIncorrect;
		}
	}
};

const getNextProblemData = function(problem) {
	if (problem && problem.model) {
		return _.pick(problem.model, ["problemID", "blockID"]);
	} else {
		return null;
	}
};

//Add in the problemID or enough information on a generated problem to recreate it
//as well as the blockID
const addReviewProblemSourceData = function(problemData, problem) {
	if (problem.problemID) {
		return _.extend({}, problemData, {
			id: problem.problemID,
			blockID: problem.blockID,
		});
	} else {
		return _.extend({}, problemData, {
			generatorID: problem.model.generatorID,
			seed: problem.model.problemSeed,
			blockID: problem.blockID,
		});
	}
};

const computeBackendProgress = function(result, defaultProgress) {
	return _.extend({}, defaultProgress, {
		streakScore: result.streakScore,
		starsEarnedSoFar: result.starsEarnedSoFar,
		hasQuit: result.hasQuit,
		//Adding the problemIDs to the list of problems
		problems: defaultProgress.problems.map((p, i) =>
			addReviewProblemSourceData(p, result.problems[i])
		),
		nextProblemCorrect: getNextProblemData(result.nextProblemCorrect),
		nextProblemIncorrect: getNextProblemData(result.nextProblemIncorrect),
	});
};

const processPostSubmission = function(result, processor) {
	const lastOutcome = result.problems[result.currentProblemIndex].outcome;
	if (!lastOutcome) {
		//The problem is not yet complete; no need to adjust scores/move to the next problem.
		return result;
	} else {
		const newResult = _.clone(result);
		if (lastOutcome === "correct") {
			newResult.streakScore++;
		} else {
			newResult.streakScore = Math.floor(newResult.streakScore / 2);
		}
		if (!isFinished(newResult)) {
			const nextProblemType =
				lastOutcome === "correct"
					? "nextProblemCorrect"
					: "nextProblemIncorrect";
			if (newResult[nextProblemType]) {
				//Add the next problem to the list
				newResult.problems = _.concat(
					newResult.problems,
					newResult[nextProblemType]
				);
			} else {
				//The next problem hasn't loaded correctly yet; add a flag so the result will add it in when it arrives.
				newResult.needsNextProblemType = nextProblemType;
				newResult.problems = _.concat(newResult.problems, {isLoading: true});
			}
		}
		newResult.nextProblemIncorrect = null;
		newResult.nextProblemCorrect = null;
		return newResult;
	}
};

const getStars = function(result) {
	return Math.max(
		result.starCutoffs.filter(c => c <= result.streakScore).length,
		result.starsEarnedSoFar
	);
};

const getSetProgressInfo = function(result) {
	return {
		viewType: "standard",
		data: {},
	};
};

const getSummaryInfo = function(result) {
	return {
		viewType: "standard",
		data: {
			problemsSolvedText: "",
		},
	};
};

const getStarProgressInfo = function(result) {
	const starMessages = {};
	const positionStrings = {1: "first", 2: "second", 3: "third"};
	for (let i = 0; i < 3; i++) {
		starMessages[i + 1] =
			"Get your streak to the " + positionStrings[i + 1] + " bar.";
	}

	return {
		styleType: result.styleType,
		filledAmount: result.streakScore,
		totalAmount: result.starCutoffs[0],
		starsAvailable: result.starsAvailable,
		allCutoffs: result.starCutoffs,
		starCutoffs: result.starCutoffs,
		keepStarsReached: true,
		modalInfo: {
			resultType: "review",
			showLimitedStarsMessage: false,
			starMessages,
			messageSize: "extra-extra-large",
		},
	};
};

module.exports = {
	getPercentComplete,
	isFinished,
	getLastAvailableIndex,
	getLastPossibleIndex,
	getEquivalentCurrentProblem,
	computeBackendProgress,
	processPostSubmission,
	getSetProgressInfo,
	getStars,
	settings,
	getSummaryInfo,
	getStarProgressInfo,
};
